module.exports = __webpack_public_path__ + "img/media-header.423f9065.png";